import React from 'react';
import styled from 'styled-components';
import Header from 'View/Component/Header/Header';
import Footer from 'View/Component/Footer/Footer';
import PageContentRenderer from 'View/Component/PageContentRenderer/PageContentRenderer';

const PageContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 1.5rem 4rem;
  min-height: 50vh;
`;

const Headline = styled.h1`
  font-family: 'Abel', sans-serif;
  font-weight: 600;
  font-size: clamp(2rem, 4vw, 3rem);
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.main};
  margin: 0 0 1.5rem;
  border-bottom: 3px solid ${({ theme }) => theme.colors.main};
  padding-bottom: 0.75rem;
  display: inline-block;
`;

const Empty = styled.div`
  font-family: 'Abel', sans-serif;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 1rem;
  padding: 3rem 0;
  text-align: center;
  font-style: italic;
`;

interface Props {
  slug: string;
  title: string;
  children?: React.ReactNode;
}

const ContentPage: React.FC<Props> = ({ slug, title, children }) => {
  return (
    <>
      <Header />
      <PageContainer data-testid={`content-page-${slug}`}>
        <Headline>{title}</Headline>
        <PageContentRenderer slug={slug} />
        {children}
      </PageContainer>
      <Footer />
    </>
  );
};

export default ContentPage;
